import { getListReportRechargeAPI, getListReportRechargeExcelAPI } from "../../../api/report";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ParamsReport, ReportRechargeState } from "../../../types/report";
import { Constant } from "../../../config/constant";
import { toast } from "react-toastify";

const limit_pagination: any = window.localStorage.getItem("limit_pagination");
const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

const initialState = {
    listReport: [],
    loading: false,
    pagination: {
        total: 0,
        per_page: limitPagination,
        current_page: Constant.DEFAULT_PAGE,
        last_page: Constant.DEFAULT_PAGE,
    },
    listRoute: [],
    total_prices: 0,
    filter: {
        options: 'confirmed_time',
        from: '',
        to: '',
        office_id: undefined,
    }
} as ReportRechargeState;

export const reportRechargeCompanySlice = createSlice({
    name: 'reportRechargeCompany',
    initialState,
    reducers: {
        setFilterOptions(state, action: PayloadAction<string>) {
            state.filter.options = action.payload;
        },
        setFilterRangeDate(state, action: PayloadAction<any>) {
            state.filter.from = action.payload?.[0];
            state.filter.to = action.payload?.[1];
        },
        setFilterAgent(state, action: PayloadAction<number | undefined>) {
            state.filter.office_id = action.payload;
        },
        setPerPage(state, action: PayloadAction<number>) {
            state.pagination.per_page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getListReportRechargeCompany.pending, (state) => {
                state.loading = true;
            }).addCase(getListReportRechargeCompany.fulfilled, (state, action) => {
                state.loading = false;
                state.listReport = action?.payload?.data;
                state.total_prices = action.payload?.total_prices;
                state.pagination.total = action.payload?.pagination?.total;
                state.pagination.per_page = action.payload?.pagination?.per_page;
                state.pagination.last_page = action.payload?.pagination?.last_page;
                state.pagination.current_page = action.payload?.pagination?.current_page;
            }).addCase(getListReportRechargeCompany.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach((fieldName) => {
                        toast.error(`${[listErros[fieldName]]}`);
                    });
                }
                state.loading = false;
            }).addCase(getListReportRechargeCompanyExcel.pending, (state) => {
            }).addCase(getListReportRechargeCompanyExcel.fulfilled, (state, action) => {
            }).addCase(getListReportRechargeCompanyExcel.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach(fieldName => {
                        toast.error(`${[listErros[fieldName]]}`)
                    })
                }
            })
    }
})

export const getListReportRechargeCompany = createAsyncThunk('ReportRechargeCompany/getAll', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportRechargeAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getListReportRechargeCompanyExcel = createAsyncThunk('ReportRechargeCompany/getAllExcel', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportRechargeExcelAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const { setPerPage, setFilterOptions, setFilterRangeDate, setFilterAgent } = reportRechargeCompanySlice.actions;